import { render, staticRenderFns } from "./ReceiptsHelp.vue?vue&type=template&id=4a639980&scoped=true"
import script from "./ReceiptsHelp.vue?vue&type=script&lang=js"
export * from "./ReceiptsHelp.vue?vue&type=script&lang=js"
import style0 from "./ReceiptsHelp.vue?vue&type=style&index=0&id=4a639980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a639980",
  null
  
)

export default component.exports